<script>
import { ref, reactive, onMounted } from 'vue'
import Recaptcha from '../../common/components/Recaptcha.vue'
import InputText from '../node-landing-fioul/InputText.vue'
import InputSelect from './InputSelect.vue'
import { useForm } from 'vee-validate';
import * as yup from 'yup';


export default {
  name: 'PageLandingLivreBlanc',
  components: {
    Recaptcha,
    InputText,
    InputSelect,
  },
  props: {
    optin: {
      type: String,
      default: '',
    },
    hasmezzo: {
      type: String,
      default: '0',
    },
  },
  setup(props) {
    const selects = reactive({
      types: [
        'Industrie',
        'Immobilier',
        'Collectivités locales',
        'Agriculture',
        'Copropriété',
        'Hôtel / Restaurant',
        'Commerce',
        'Garage',
        'TPE/PME',
        'EHPAD',
        'Autre secteur',
      ],
    })

    const form = reactive({
      lastname: '',
      firstname: '',
      type: '',
      phone: '',
      email: '',
      company_name: '',
      captcha: '',
      mention: '',
      specify_your_request: '',
      mezzo: props.hasmezzo,
    })


    const { values, errors, defineField, validate } = useForm({
          validationSchema: yup.object({
            lastname: yup.string().required('Le nom est requis'),
            firstname: yup.string().required('Le prénom est requis'),
            type: yup.string().required('Le type est requis'),
            companyname: yup.string().required('Le nom de la companie est requis'),
            email: yup.string().email('L\'email est invalide').required('L\'email est requis'),
              }),
            phone: yup
              .string()
              .matches(/^(0|\+33)[0-9]{9}$/, 'Le numéro de téléphone est invalide'),
        });

    const [type, typenameAttrs] = defineField('type', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [companyname, companynameAttrs] = defineField('companyname', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [lastname, lastnameAttrs] = defineField('lastname', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [firstname, firstnameAttrs] = defineField('firstname', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [email, emailAttrs] = defineField('email', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [phone, phoneAttrs] = defineField('phone', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const formEl = ref(null)
    const isPosted = ref(false)
    const captchaError = ref(false)
    const recaptcha = ref(null)

    const updateDatalayer = (formData) => {
      window.dataLayer.push({
        event: 'form_confirmation',
        ...formData,
      })
    }

    const onCaptchaExpired = () => {
      recaptcha.value.reset()
      captchaError.value = true
    }

    const onCaptchaVerified = (token) => {
      recaptcha.value.reset()
      form.captcha = token
      submitForm()
    }

    const checkRecaptcha = () => {
      captchaError.value = false
      recaptcha.value.execute()
    }

    const submitForm = () => {
      if (form.captcha.length > 0) {
        sendForm()
      }
    }

    const sendForm = () => {

      form.lastname = lastname
      form.firstname = firstname
      form.type = type
      form.phone = phone
      form.email = email
      form.company_name = companyname

      const formData = {
        event: 'form_confirmation',
        form_type: 'Livre_blanc',
        form_name: 'PageLandingLivreBlanc',
        form_category: form.type
          ?.trim()
          .replace(/[#_',\/]/g, '_')
          .replace(/["+?! ]/g, '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, ''),
      }

      Object.entries(form).forEach(([key, value]) => {
        let input = formEl.value?.querySelector(`[name='${key.toLowerCase()}']`)

        if (input) {
          switch (key) {
            case 'mention':
              input.value = value ? props.optin : ''
              break
            case 'acceptance':
              input.value = 'Envoyer mon email'
              break
            default:
              input.value = value
              break
          }
        }
      })

      updateDatalayer(formData)
      formEl.value?.submit()
    }

    const pushToDataLayer = (event) => {
      if (event) {
        window.dataLayer.push({
          event: 'click',
          click: event.target.textContent
            .replace(/\s\s+/g, ' ')
            .replace(/["+?!]/g, '')
            .replace(/[#_', ]/g, '_')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, ''),
          click_type: 'navigation',
          event_location: 'content',
        })
      }
    }

    onMounted(() => {
      window.dataLayer = window.dataLayer || []

      formEl.value = document.querySelector('form')
      isPosted.value = formEl.value?.querySelector('.webform-confirmation') !== null

      const itemToPush = {}
      const H1 = document.querySelector('h1')

      if (H1) {
        itemToPush['pagename'] = H1.textContent
          .replace(/\s\s+/g, ' ')
          .replace(/["+?!]/g, '')
          .replace(/[#_', ]/g, '_')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
      }

      itemToPush['pagetype'] = 'Landing page'
      itemToPush['event'] = 'page_load'

      window.dataLayer.push(itemToPush)
    })

    return {
      selects,
      form,
      formEl,
      isPosted,
      captchaError,
      recaptcha,
      updateDatalayer,
      onCaptchaExpired,
      onCaptchaVerified,
      checkRecaptcha,
      submitForm,
      sendForm,
      pushToDataLayer,
      type,
      firstname,
      lastname,
      companyname,
      email,
      phone,
      errors,
      values
    }
  },
}
</script>

<style scoped lang="sass">
@import LandingLivreBlanc
</style>
